module.exports = "images/grey.5dfb4be0656bc180d736e6b7ee952eb5.png";